import React, { useEffect, useState } from 'react';
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

const AddSubjectButton = styled(Button)(({ theme }) => ({
  marginLeft: theme.spacing(2)
}));
const SubjectTextField = styled(TextField)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    width: '100%'
  },
  margin: theme.spacing(0.5, 0),
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#999',
    }
  },
}));

type SubjectComponentProps = {
  disabled?: boolean;
  forceReset?: boolean;
  onSubjectChanged: (value: string) => void;
}

export default function SubjectButton(props: Readonly<SubjectComponentProps>) {
  const {
    disabled,
    forceReset,
    onSubjectChanged
  } = props;

  const [addingSubject, setAddingSubject] = useState(false);
  const [subject, setSubject] = useState('');

  useEffect(() => {
    if (forceReset) {
      setAddingSubject(false);
      setSubject('');
      onSubjectChanged('');
    }
  }, [forceReset, onSubjectChanged]);

  return (
    <React.Fragment>
      {!addingSubject && (
        <AddSubjectButton
          disabled={disabled}
          size='small'
          onClick={() => setAddingSubject(true)}>
          Add Subject
        </AddSubjectButton>
      )}
      {addingSubject && (
        <SubjectTextField
          placeholder='Subject'
          value={subject}
          size='small'
          onChange={(event) => {
            setSubject(event.target.value);
            onSubjectChanged(event.target.value);
          }}
          slotProps={{
            input: {
              endAdornment: (
                <IconButton
                  size='small'
                  onClick={() => {
                    setAddingSubject(false);
                    setSubject('');
                  }}>
                  <CloseIcon />
                </IconButton>
              )
            }
          }}
        />
      )}
    </React.Fragment>
  );
}
